import { useSelector } from "react-redux";
import { AUTHORITY_TYPE } from "../const";
import {
  getFieldAuthority,
  getFormAuthority,
  getModuleAuthority,
} from "../auth/authHelper";

const useAuthority = ({
  type = AUTHORITY_TYPE.FIELD,
  module = "",
  form = "",
  field = "",
  editMode,
  authenticated = false,
  needDeletePermission = false,
}) => {
  const permissions = useSelector((state) => state.user.permissions);

  if (!authenticated) return { view: true, authorized: true };

  if (!permissions) {
    return { view: false, authorized: false };
  }
  const auth = permissions[module];

  switch (type) {
    case AUTHORITY_TYPE.FIELD: {
      return getFieldAuthority(
        auth,
        form,
        field,
        needDeletePermission,
        editMode,
      );
    }
    case AUTHORITY_TYPE.FORM:
      return getFormAuthority(auth, form, editMode);
    case AUTHORITY_TYPE.MODULE:
      return getModuleAuthority(auth);
    default:
      return { view: false, authorized: false };
  }
};

export default useAuthority;
